import { MYDRA_WORKSPACE_ID_HEADER_NAME } from '@/config/system'
import { PlaybooksService } from '@/services/playbook'
import { useWorkspaceContext } from '@/shared/hooks/useWorkspaceContext'
import { ApiErrorResponse, ApiIndividualResponse } from '@/types/api'
import { Playbook } from '@/types/playbook'
import { useQuery, UseQueryOptions } from '@tanstack/react-query'

export type UsePlaybookOptions = {
  id: string
  queryOptions?: Omit<
    UseQueryOptions<
      ApiIndividualResponse<Playbook>,
      ApiErrorResponse,
      ApiIndividualResponse<Playbook>
    >,
    'queryKey' | 'queryFn'
  >
}

export const usePlaybook = ({ id, queryOptions = {} }: UsePlaybookOptions) => {
  const { workspaceId } = useWorkspaceContext()

  return useQuery({
    queryKey: [
      'playbooks',
      id,
      ...(workspaceId ? ['workspaceId', workspaceId] : []),
    ],
    queryFn: () =>
      PlaybooksService.getPlaybookById(id, {
        headers: {
          [MYDRA_WORKSPACE_ID_HEADER_NAME]: workspaceId,
        },
      }),
    ...queryOptions,
  })
}
